module.exports = __webpack_public_path__ + "static/img/ikonaMuzyka-ON.cf266f86.png";